import { useQuery } from '@apollo/react-hooks';
import gqlTagSwag from 'graphql-tag';
import type { TimeTrackingOptions as Response } from './__generated_apollo__/TimeTrackingOptions';

export const TIME_TRACKING_OPTIONS_QUERY = gqlTagSwag`
query TimeTrackingOptions {
  jira {
    timeTrackingOptions {
      workingHoursPerDay
      workingDaysPerWeek
      defaultUnit
      timeFormat
    }
  }
}`;

const useTimeTrackingOptionsQuery = () =>
	useQuery<Response, null>(TIME_TRACKING_OPTIONS_QUERY, {
		notifyOnNetworkStatusChange: true,
	});

export default useTimeTrackingOptionsQuery;
